import { useRef, useState, memo } from 'react';

import { Box, Button, TextField } from '@mui/material';

import './styles.css';
import styles from './styles';

const NotePopup = ({ content, closePopup, saveContent, editContent, isEditForm, title }) => {
  const inputRef = useRef(null);
  const [isSave, setIsSave] = useState(false);
  const handleChange = () => {
    if (!isSave && inputRef.current.value) {
      setIsSave(true);
    } else if (inputRef.current.value === '') {
      setIsSave(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.headerTitle}>{title}</div>
      <Box>
        <Box display='flex' gap={2} flexDirection={'column'}>
          <TextField
            multiline
            rows={5}
            variant="outlined"
            fullWidth
            defaultValue={content}
            placeholder={`Add note here...`}
            inputRef={inputRef}
            onChange={handleChange}
          />

          <Box display='flex' justifyContent='center' gap={1}>
            <Button variant="outlined" size='small' disableElevation onClick={closePopup}>
              Cancel
            </Button>
            <Button variant="contained" size='small' color='primary' disableElevation disabled={!isSave} onClick={() => {
                if (!isEditForm) {
                  saveContent(inputRef.current?.value);
                } else {
                  editContent(inputRef.current?.value);
                }
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
    </div>
  );
};
export default memo(NotePopup);
